const tooltips = {
  raktar: 'A funkció célja, hogy a felhasználó a saját igényei szerint alakíthassa ki raktárát, raktárait. Az új raktár a berögzítése után, csak akkor lesz látható, ha az azonosítónak megfelelő szerepkör kialakításra kerül (ROLE_RAKTAR_KOD_AZONOSITO). A továbbiakban az adott raktár csak akkor lesz listában kiválasztható, ha a felhasználóhoz a szerepkör hozzá lett rendelve (Törzsadatok / Felhasználók menüpont, Módosítás funkció)',
};

export default function getTooltip(name) {
  return tooltips[name];
}
